/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    OffenceBulletpoint: {
        id: 'spm.components.SgSpmDeclarationsBullets.OffenceBulletpoint',
        defaultMessage: 'It is an offence under the Road Traffic Acts to make any false statement or withhold any material information for the purpose of obtaining a Certificate of Insurance.'
    },
    FraudBulletpoint: {
        id: 'spm.components.SgSpmDeclarationsBullets.FraudBulletpoint',
        defaultMessage: 'If false or inaccurate information is provided and fraud is identified, details will be passed to fraud prevention agencies to prevent fraud and money laundering (further details can be found within Saga\'s '
    },
    FraudLink: {
        id: 'spm.components.SgSpmDeclarationsBullets.FraudLink',
        defaultMessage: 'Fraud prevention section'
    },
});
